import FirebaseProjectFunctions from "./../../firebase/firebase-functions/project-service";
import * as projectActions from "../actions/project.actions";
import {ThunkResult} from "../store.types";
import FirebaseUsage from "../../firebase/firebase.usage";
import {COLLECTIONS} from "../../firebase/constants";
import cpmFunctionsController from "../../utils/cpm-functions/cpm-functions.controller";
import RouteNameConstants from "../../constants/route-name.constants";

export class ProjectThunk {
  static setActiveProjectId(
    projectId: string | undefined | null
  ): ThunkResult<Promise<void>> {
    return async (dispatch) => {
      dispatch(projectActions.Actions.setActiveProjectId(projectId));
    };
  }

  static deleteProject(
      projectId: string,
      navigate: any
  ): ThunkResult<Promise<void>> {
    return async (dispatch, getState) => {
      const user = getState().authorization.user;
      const activeProjectId = getState().project.activeProject?.projectId;
      if (!user) {
        return console.error("No authorized user");
      }
      try {
        FirebaseUsage.updateDoc(COLLECTIONS.PROJECTS, projectId, {
            deleted: true,
            deletedAt: FirebaseUsage.timestamp(),
            deletedBy: user.userId
        }).then(() => {
            if (activeProjectId === projectId) {
                dispatch(ProjectThunk.setActiveProjectId(null));
                navigate(`/${RouteNameConstants.CHOOSE_PROJECT}`);
            }
        });
      } catch (e) {
        console.error("deleteProject Error: ", e);
      }
    };
  }

  static async runRacingLines(data: any[], dispatch) {
      try {
          for (const el of data) {
              const projectId = el.id
              await FirebaseProjectFunctions.fullCPMCalc(projectId, "true", dispatch, true, null)
          }
          return true
      } catch (e) {
          return false
      }
  }
    static async runMonteCarlo(projectId: string, dispatch, trackedMilestones: any[] = [], upperLimit, lowerLimit, iterations) {
        try {
            return await cpmFunctionsController.runMonteCarlo(trackedMilestones, upperLimit, lowerLimit, projectId, dispatch, iterations)
        } catch (e) {
            return false
        }
    }
}
